<template>
    <div class="w-full sm:w-1/3 lg:w-64 mt-0 sm:mt-6 px-0 sm:px-2">
        <!-- <category-ad v-if="category.name === 'ad'" />
        <div v-else> -->
            <div @click.prevent.stop="openCategory" class="card card-product rounded shadow-none cursor-pointer transition duration-200 border border-gray-300 hover:border-gray-400 hover:shadow-md focus:shadow-inner">
                <div v-cloak v-if="category.featured === true" class="marker marker-ribbon marker-warning absolute t-10 left-0 text-sm hidden sm:block">
                    HOT
                    <i class="far fa-fire-alt ml-2"></i>
                </div>
                <div v-cloak v-if="isNew" class="marker marker-ribbon marker-success absolute t-10 left-0 text-sm hidden sm:block">
                    NEW
                </div>

                <div class="card-body pt-2 pb-4 px-3 text-left sm:text-center cursor-pointer border-0 flex sm:flex-wrap sm:justify-center items-center sm:h-56" style="border:0 !important;" class2="py-4">
                    <div class="sm:w-full">
                        <img v-if="category.image_url" :data-src="category.image_url" :alt="category.name" class="lazyload object-contain h-20 w-20 sm:h-32 sm:w-full" class2="card-img" />
                    </div>

                    <div v-if="category.icon" class="sm:w-full opacity-50 text-center flex justify-center items-center text-4xl sm:text-6xl text-muted h-20 w-20" class2="sm:h-32">
                        <i :class="category.icon" class="fal fa-lg"></i>
                    </div>

                    <h3 class="sm:text-center ml-5 sm:ml-0 mt-0 sm:mt-4 mb-0 sm:mb-0 text-lg sm:text-xl font-bold overflow-hidden text-truncate2" class2="sm:h-16">
                        <a @click.prevent="openCategory" :href="category.link">{{ category.name }}</a>
                    </h3>

                    <!-- <div class="w-full mt-2">
                        <button type="button" class="btn btn-block btn-primary border-2 rounded-full font-semibold">
                            arrow icon
                        </button>
                    </div> -->
                </div>
            </div>
        <!-- </div> -->
    </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';

export default {
    props: ['category'],

    data: () => ({}),

    created() {},

    mounted() {},

    beforeDestroy() {},

    computed: {
        isNew() {
            const createdAt = this.category.created_at;
            if (isEmpty(createdAt)) return false;
            return false;
            // var created = moment(createdAt);
            // var filter = moment().subtract(1, 'days');
            // return created.isAfter(filter);
        }
    },

    methods: {
        openCategory($event) {
            $event.preventDefault();
            $event.stopPropagation();

            window.location.href = this.category.link;
        }
    }
}
</script>

<style lang="scss" scoped>
.card-product {
    .card-body {
        border-left-width: 0;
        border-right-width: 0;
    }
}
</style>
